export const getGetGroundTokenIsLoading = state => state.getGround.getGroundToken.get.loading;
export const getGetGroundTokenIsSuccess = state => state.getGround.getGroundToken.get.success;
export const getGetGroundTokenIsError = state => state.getGround.getGroundToken.get.error;